import { ExtratoRepasseDetalhadoType } from '../../types/extratoRepasse.types';
import * as httpHelper from '../../utils/http-helper';

function buscarContratos(cpf: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseContratos?_cpf=${cpf}&_idTipoInfo=2`
  );
}

function buscarDatasPagamento(cpf: string, contrato: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseDataPagamento?_cpf=${cpf}&_cdContrato=${contrato}&_idTipoInfo=2`
  );
}

function buscarExtratosRepasseDetalhado(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get<ExtratoRepasseDetalhadoType>(
    headers,
    `ExtratoRepasseDetalhado?_cpf=${cpf}&_dtPagamento=${dataPagamento.split('T')[0]}&_cdContrato=${contrato}`
  );
}
/* 
function buscarExtratosRepasse(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasse?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarRelatorioProdutividade(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseProdutividade?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarProcedimento(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseProcedimento?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarPlantaoNormal(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepassePlantaoNormal?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarPlantaoSobreaviso(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepassePlantaoSobreAviso?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarPlantaoNormalResumo(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepassePlantaoNormalResumoTurno?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarPlantaoSobreavisoResumo(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepassePlantaoSobreAvisoResumoTurno?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarProducaoNormal(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseProducaoNormalAgrupado?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}

function buscarProducaoSobreaviso(cpf: string, contrato: string, dataPagamento: string) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ExtratoRepasseProducaoSobreAviso?_cpf=${cpf}&_dtPagamento=${dataPagamento}&_cdContrato=${contrato}`
  );
}
 */
const extratoRepasseService = {
  buscarContratos,
  buscarDatasPagamento,
  buscarExtratosRepasseDetalhado,
  // buscarExtratosRepasse,
  // buscarRelatorioProdutividade,
  // buscarProcedimento,
  // buscarPlantaoNormal,
  // buscarPlantaoSobreaviso,
  // buscarPlantaoNormalResumo,
  // buscarPlantaoSobreavisoResumo,
  // buscarProducaoNormal,
  // buscarProducaoSobreaviso,
}

export default extratoRepasseService;
